<template>
    <CategoryTop :title="$t('contact.categories.touch.title')" :breadcrumbs-parent-routes="breadcrumbsParentRoutes"
        :description="$t('contact.categories.touch.desc')" mainClass="training-container" />
</template>

<script setup>
import CategoryTop from "../../General/CategoryTop/index.vue";
import { computed } from "vue";
import { useTenantConfig } from "@/composables/useTenantConfig";
const { tenantConfig } = useTenantConfig();
const breadcrumbsParentRoutes = computed(() =>
    (tenantConfig.value?.serviceNumberBreadcrumbsParentRoutes ?? [])
);
</script>